export default __webpack_public_path__ + "static/media/05.e1829f4b.png";